<button
  type="button"
  [disabled]="disabled() || loading()"
  class="inline-flex items-center justify-center gap-2 rounded-xl px-4 py-2 font-semibold transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer w-full"
  [ngClass]="variantClasses()"
  (click)="handleClick($event)"
>
  <ng-content />

  @if (loading()){
  <span class="button-loader animate-spin"></span>
  }
</button>
